<template>
  <div class="w-100">
    <div class="header d-flex align-items-center w-100 justify-content-between">
      <p class="header-title mb-0">Deferred tax liabilities</p>
      <p class="header-title mb-0">
        {{ NumberFormatter(totalNonCurrentLiability.deferred_tax_liabilities) }}
      </p>
    </div>
    <form
      :id="item.model"
      @submit="handleSubmit"
      v-for="(item, index) in data"
      :key="item.id"
      :class="`w-100 table-body ${!index || !(index % 2) ? 'white' : 'gray'} ${
        item?.sub ? 'sub' : ''
      } d-flex align-items-center justify-content-between`"
    >
      <p class="mb-0 body-title">
        {{ item.name }}
      </p>
      <p
        v-if="!item.showInput"
        class="body-title mb-0"
        @click="openCloseInput(item.model, true)"
      >
        {{ NumberFormatter(nonCurrentLiability[item.model]) }}
      </p>

      <input
        :id="'input-' + item.model"
        :hidden="!item.showInput"
        v-model="nonCurrentLiability[item.model]"
        type="number"
        class="clickable-text"
        @blur="openCloseInput(item.model, false)"
        @keydown.tab="(e) => handleTab(e, item.model)"
      />
    </form>
  </div>
</template>

<script setup>
import { generate } from "randomized-string";
import { ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useLiabilityDataStore } from "../../../../../store/liabities.store";
import { NumberFormatter } from "../../../../../helpers/numberFormatter";
import { useRoute } from "vue-router";
const route = useRoute();

const props = defineProps({
  view: {
    type: Boolean,
    default: false
  }
});

const liabilityDataStore = useLiabilityDataStore();
const { nonCurrentLiability, totalNonCurrentLiability } =
  storeToRefs(liabilityDataStore); //get initialvalue from store
const data = ref([
  {
    id: generate(),
    name: "1. Deferred tax assets (+)",
    sub: false,
    showInput: false,
    amount: "0000.00",
    model: "deferred_tax_liabilities_deferred_tax_assets"
  },
  {
    id: generate(),
    name: "2. Deferred tax Liabilities (-)",
    sub: false,
    showInput: false,
    amount: "0000.00",
    model: "deferred_tax_liabilities_deferred_tax_liabilities"
  }
]);
const openCloseInput = async (model, value) => {
  if (props.view || route.query.business === "master") {
    return;
  }
  const newValues = data.value.map((item) => {
    if (item.model === model) {
      return { ...item, showInput: value };
    }
    return item;
  });
  data.value = newValues;
  if (value) {
    const input = await document.getElementById(`input-${model}`);
    input.focus();
  }
};
totalNonCurrentLiability.value.deferred_tax_liabilities = data.value.reduce(
  (a, b) => {
    if (b.model === "deferred_tax_liabilities_deferred_tax_liabilities") {
      return a - Number(nonCurrentLiability.value[b.model]);
    }
    return a + Number(nonCurrentLiability.value[b.model]);
  },
  0
);

watch(
  nonCurrentLiability,
  (newValue) => {
    totalNonCurrentLiability.value.deferred_tax_liabilities =
      data.value?.reduce((a, b) => {
        if (b.model === "deferred_tax_liabilities_deferred_tax_liabilities") {
          return a - Number(newValue[b.model]);
        }
        return a + Number(newValue[b.model]);
      }, 0);
  },
  { deep: true }
);
const handleSubmit = async (e) => {
  e.preventDefault();
  let current_model = e.target.id;
  let next_model =
    data.value[data.value.map((e) => e.model).indexOf(current_model) + 1];
  // close current  input
  openCloseInput(current_model, false);
  if (next_model) {
    await openCloseInput(next_model.model, true);
  }
};
const handleTab = async (e, current_model) => {
  e.preventDefault();
  let next_model =
    data.value[data.value.map((e) => e.model).indexOf(current_model) + 1];
  // close current  input
  openCloseInput(current_model, false);
  if (next_model) {
    await openCloseInput(next_model.model, true);
  }
};
</script>

<style scoped>
.header {
  min-height: 44px;
  background: #0f75bc;
  padding-right: 100px;
  padding-left: 10px;
}

.header-title {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.055em;
  color: #fafbff;
}

.table-body {
  height: 44px;
  padding-right: 100px;
  padding-left: 26px;
}

.body-title {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.055em;
  color: #382628;
}

.white {
  background: #fafbff;
}

.gray {
  background: #deeded;
}

.table-body.sub {
  padding-left: 46px;
}
</style>
